// @ts-expect-error pure js
import useAccount from "./use-account";
// @ts-expect-error pure js
import useAuthenticatedAxios from "./use-authenticated-axios";
import {
  DEFAULT_ONBOARDING_STATE,
  type OnboardingSegment,
  type OnboardingState,
} from "../models/onboarding";

export default function useOnboarding() {
  const axios = useAuthenticatedAxios();
  const { account, isLoading, refresh } = useAccount();

  const onboarding: OnboardingState =
    account?.onboarding ?? DEFAULT_ONBOARDING_STATE;

  async function update(patch: Partial<OnboardingState>) {
    await axios.patch("account/onboarding", patch);
    await refresh();
  }

  function hasSeenGuide(guideId: string) {
    return onboarding.seen_guides.includes(guideId);
  }

  async function markGuideSeen(guideId: string) {
    if (hasSeenGuide(guideId)) return;
    await update({ seen_guides: [...onboarding.seen_guides, guideId] });
  }

  async function setSegment(segment: OnboardingSegment) {
    await update({ segment });
  }

  async function dismissMission(missionId: string) {
    if (onboarding.dismissed_missions.includes(missionId)) return;
    await update({
      dismissed_missions: [...onboarding.dismissed_missions, missionId],
    });
  }

  async function completeMission(missionId: string) {
    if (onboarding.completed_missions.includes(missionId)) return;
    await update({
      completed_missions: [...onboarding.completed_missions, missionId],
    });
  }

  async function setChecklistCollapsed(
    checklistId: string,
    collapsed: boolean,
  ) {
    const without = onboarding.collapsed_checklists.filter(
      (id) => id !== checklistId,
    );
    await update({
      collapsed_checklists: collapsed ? [...without, checklistId] : without,
    });
  }

  return {
    onboarding,
    isLoading,
    gating: onboarding.gating,
    hasSeenGuide,
    markGuideSeen,
    setSegment,
    dismissMission,
    completeMission,
    setChecklistCollapsed,
  };
}
